module.exports = __webpack_public_path__ + "static/media/Esam_AlselwiResume_ML_EN.370158b9.pdf";